import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "@studio-freight/lenis";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";
import { AuthProvider } from "@/components/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import ImmigrationServices from "@/pages/ImmigrationServices";
import About from "@/pages/About";
import AdditionalServices from "@/pages/AdditionalServices";
import Contact from "@/pages/Contact";
import StaffLogin from "@/pages/StaffLogin";
import StaffDashboard from "@/pages/StaffDashboard";
import ManageBooking from "@/pages/ManageBooking";

const SmoothScroll = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const StaffAuth = ({ children }) => <AuthProvider>{children}</AuthProvider>;

export default function App() {
  return (
    <BrowserRouter>
      <SmoothScroll />
      <Routes>
        <Route path="/staff/login" element={<StaffAuth><StaffLogin /></StaffAuth>} />
        <Route path="/staff" element={<StaffAuth><ProtectedRoute><StaffDashboard /></ProtectedRoute></StaffAuth>} />
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="immigration-services" element={<ImmigrationServices />} />
          <Route path="about" element={<About />} />
          <Route path="additional-services" element={<AdditionalServices />} />
          <Route path="contact" element={<Contact />} />
          <Route path="manage-booking/:bookingId" element={<ManageBooking />} />
        </Route>
      </Routes>
      <Toaster richColors position="top-center" />
    </BrowserRouter>
  );
}
